"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassName = exports["default"] = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["className", "clickable"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "button": "htIL4h",
  "clickable": "gMTmnf"
};
var getClassName = exports.getClassName = function getClassName(_ref) {
  var className = _ref.className,
    clickable = _ref.clickable;
  return (0, _clsx["default"])(className, styles.button, clickable && styles.clickable);
};
var Button = exports.Button = function Button(_ref2) {
  var className = _ref2.className,
    clickable = _ref2.clickable,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/(
    // eslint-disable-next-line react/button-has-type
    _react["default"].createElement("button", _extends({
      className: getClassName({
        className: className,
        clickable: clickable
      })
    }, props))
  );
};
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  clickable: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Button;